export const USERNAME_VALIDATION_MESSAGES = {
  spaces: "Spaces are not permitted in usernames.",
  lowercase: "Usernames should be lowercase only.",
  min: "Username must be at least 3 characters.",
  max: "Username cannot exceed 20 characters.",
} as const;

const MIN_LEN = 3;
const MAX_LEN = 20;

export function getUsernameValidationError(value: string): string | undefined {
  const trimmed = value.trim();
  if (trimmed.length < MIN_LEN) return USERNAME_VALIDATION_MESSAGES.min;
  if (trimmed.length > MAX_LEN) return USERNAME_VALIDATION_MESSAGES.max;
  if (/\s/.test(trimmed)) return USERNAME_VALIDATION_MESSAGES.spaces;
  if (trimmed !== trimmed.toLowerCase())
    return USERNAME_VALIDATION_MESSAGES.lowercase;
  return undefined;
}

function fieldMessageFromErrorsObject(
  errors: Record<string, unknown>,
  field: string,
): string | undefined {
  const v = errors[field];
  if (Array.isArray(v) && v.length > 0 && v[0] != null) return String(v[0]);
  if (typeof v === "string") return v;
  return undefined;
}

function pickFieldServerError(err: unknown, field: string): string | undefined {
  const data = (err as { data?: Record<string, unknown> })?.data;
  if (!data || typeof data !== "object") return undefined;
  const wrapped = data.errors ?? data.error;
  if (wrapped && typeof wrapped === "object") {
    const fromWrapped = fieldMessageFromErrorsObject(
      wrapped as Record<string, unknown>,
      field,
    );
    if (fromWrapped) return fromWrapped;
  }
  return fieldMessageFromErrorsObject(data, field);
}

export function pickUsernameServerError(err: unknown): string | undefined {
  return pickFieldServerError(err, "username");
}

export function pickEmailServerError(err: unknown): string | undefined {
  return pickFieldServerError(err, "email");
}
